var map = {
	"./AU.png": "BN1X",
	"./CA.png": "Lffc",
	"./DE.png": "0Xba",
	"./FR.png": "knX5",
	"./GB.png": "bBlr",
	"./IT.png": "kmv6",
	"./JP.png": "8bRx",
	"./KR.png": "xaZh",
	"./MY.png": "mnnS",
	"./NL.png": "ZoX4",
	"./SG.png": "/vlJ",
	"./TH.png": "vnbv",
	"./US.png": "ZNSm",
	"./VN.png": "NQ7B"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "oNrm";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certified_shipping ^\.\/.*\.png$
// module id = oNrm
// module chunks = 2